<div *ngIf="showAsDialog" class="modal-header">
    <h2 class="modal-title">Invoice</h2>
</div>

<div class="modal-body p-0 flex-fill d-flex flex-column compact-form" *ngIf="!!invoice">
    <div class="card">
        <div class="card-body p-2 pb-3">
            <div class="btn-toolbar mx-0 mb-1 mt-0">
                <div>
                    <button *ngIf="hasChanges() && !showAsDialog" class="btn btn-sm btn-primary me-2" (click)="save()">Save</button>
                    <button *ngIf="hasChanges() && !showAsDialog" class="btn btn-sm btn-success me-4" (click)="cancel()">Cancel</button>
                    <button *ngIf="!hasChanges()" class="btn btn-sm btn-primary me-4" (click)="close()">Close</button>

                    <ng-container *ngIf="!showAsDialog">
                        <button *ngIf="!hasChanges() && !isInvoiceCredit" class="btn btn-sm btn-secondary me-2" (click)="print('Invoice')">Print Invoice</button>
                        <button *ngIf="!hasChanges() && !isInvoiceCredit" class="btn btn-sm btn-success me-2" (click)="emailInvoice()">Email Invoice</button>
                        <button
                            *ngIf="!hasChanges() && !isInvoiceCredit"
                            class="btn btn-sm btn-success me-2"
                            (click)="readyToExport()"
                            [disabled]="invoice.quickBooksId !== null || invoice.readyToExport"
                        >
                            Ready To Export
                        </button>
                        <button (click)="auditLog()" class="ms-2 btn btn-sm btn-info" *ngIf="!hasChanges() && !showAsDialog">Audit Log</button>
                        <button *ngIf="!hasChanges() && !isInvoiceCredit" class="btn btn-sm btn-danger ms-2 me-2" (click)="deleteInvoice()">Delete Invoice</button>
                        <button *ngIf="!hasChanges() && !isInvoiceCredit" class="btn btn-sm btn-secondary ms-2 me-4" (click)="refresh()">Refresh Data</button>
                        <button *ngIf="!hasChanges() && !isInvoiceCredit" class="btn btn-sm btn-success ms-2" (click)="receivePayment()" [disabled]="invoice.paid">
                            Receive Payment
                        </button>
                        <button *ngIf="!hasChanges() && invoice.paid && !isInvoiceCredit" class="btn btn-sm btn-success ms-2" (click)="createCredit()">Create Credit</button>
                        <button *ngIf="!hasChanges() && isInvoiceCredit" class="btn btn-sm btn-danger ms-2" (click)="cancelCredit()">Cancel Crediting</button>
                    </ng-container>
                </div>
                <div class="ms-auto d-flex align-items-center">
                    <label class="mt-2 me-2">Invoice Date</label>
                    <dx-date-box
                        class="me-3"
                        [(value)]="invoice.invoiceDate"
                        width="125px"
                        [readOnly]="invoice.quickBooksId !== null"
                        (onValueChanged)="onInvoiceDateChanged($event)"
                    ></dx-date-box>
                    <label class="mt-2 me-2">Due Date</label>
                    <dx-date-box class="me-3" [(value)]="invoice.dueDate" width="125px"></dx-date-box>
                    <h3 class="{{ invoice.statusId === 4 ? ' paid-status' : '' }}">
                        <strong>Status: {{ invoice?.status?.name.toUpperCase() }}</strong>
                    </h3>
                </div>
            </div>

            <dx-form *ngIf="invoice" [formData]="invoice" [colCount]="12">
                <dxi-item itemType="group" caption="Dealer" [colSpan]="3" [colCount]="2">
                    <dxi-item dataField="dealer.companyName" [label]="{ text: 'Dealer' }" [editorOptions]="{ readOnly: true }" [colSpan]="2"></dxi-item>
                    <dxi-item dataField="ordersListString" [label]="{ text: 'Sales Order(s) #' }" [editorOptions]="{ readOnly: true }" [colSpan]="2"></dxi-item>
                    <!-- <dxi-item dataField="deliveryMethod" [label]="{ text: 'Delivery' }" [colSpan]="2"> </dxi-item> -->
                    <dxi-item *ngIf="ready" itemType="group" [colSpan]="2" [colCount]="2">
                        <dxi-item dataField="packingSlipList" [label]="{ text: 'Pack Slip #' }" [editorOptions]="{ readOnly: true }"> </dxi-item>
                        <dxi-item dataField="invoiceNumber" [label]="{ text: 'Invoice #' }" [editorOptions]="{ readOnly: true }"> </dxi-item>
                    </dxi-item>
                    <dxi-item
                        dataField="orderPaymentMethodsListString"
                        [label]="{ text: 'Sales Order Payment Method(s)' }"
                        [editorOptions]="{ readOnly: true }"
                        [colSpan]="2"
                    ></dxi-item>
                </dxi-item>

                <dxi-item *ngIf="invoice" itemType="group" caption="Ship Address" [colSpan]="2" [colCount]="1">
                    <dxi-item>
                        <div *dxTemplate>
                            <div class="mt-1 d-flex justify-content-between">
                                <h3 class="mt-0 mb-1">{{ invoice?.shipCompanyName }}</h3>
                            </div>
                            <h3 class="mt-0 mb-1">{{ invoice?.invoiceShipInfo.shipToLocation }}</h3>
                            <div>{{ invoice.invoiceShipInfo.shipToAddress1 }}</div>
                            <div>{{ invoice.invoiceShipInfo.shipToAddress2 }}</div>
                            <div>
                                {{ invoice.invoiceShipInfo.shipToCity?.trim() }}{{ invoice?.shipToCity && ', ' }}
                                {{ invoice.invoiceShipInfo.shipToState }}
                                {{ invoice.invoiceShipInfo.shipToZip }}
                                {{ invoice.invoiceShipInfo.shipToCountry }}
                            </div>
                            <div>{{ invoice.invoiceShipInfo.shipToPhone }}</div>
                            <div>{{ invoice.invoiceShipInfo.shipToEmail }}</div>
                            <h4 *ngIf="invoice?.dealer?.salesRep?.displayName" class="mt-2 mb-0">Sales Rep {{ invoice?.dealer?.salesRep?.displayName }}</h4>
                        </div>
                    </dxi-item>
                </dxi-item>

                <dxi-item itemType="group" caption="Invoice Total" [colSpan]="2">
                    <dxi-item dataField="subTotal" [label]="{ text: 'SubTotal' }" editorType="dxNumberBox" [editorOptions]="{ format: '$#,##0.00##', readOnly: true }"></dxi-item>
                    <dxi-item
                        dataField="taxableTotal"
                        [label]="{ text: 'Taxable' }"
                        editorType="dxNumberBox"
                        [editorOptions]="{ format: '$#,##0.00##', disabled: true }"
                    ></dxi-item>
                    <dxi-item dataField="tax" editorType="dxNumberBox" [editorOptions]="{ format: '$#,##0.00##', readOnly: true }"></dxi-item>
                    <dxi-item dataField="total" editorType="dxNumberBox" [editorOptions]="{ format: '$#,##0.00##', readOnly: true }"></dxi-item>
                </dxi-item>
                <dxi-item itemType="group" caption="Attachments" [colSpan]="3">
                    <dxi-item>
                        <div *dxTemplate>
                            <ul style="list-style-type: none; padding-inline-start: 0px" *ngIf="invoiceAttachments">
                                <li *ngFor="let attachment of invoiceAttachments">
                                    <a title="remove" (click)="removeAttachment($event, attachment)"> <i class="fa fa-times" aria-hidden="true"></i> </a>&nbsp;
                                    <a title="view" (click)="openAttachment(attachment)">{{ attachment.name }}</a>
                                </li>
                            </ul>
                        </div>
                    </dxi-item>
                    <dxi-item>
                        <div *dxTemplate>
                            <dx-file-uploader
                                name="fileUpload"
                                selectButtonText="Select File(s)"
                                class="attachments"
                                accept="*"
                                uploadMode="instantly"
                                [showFileList]="false"
                                [multiple]="true"
                                [uploadUrl]="uploadUrl"
                                [uploadHeaders]="uploadHeader"
                                (onUploadStarted)="uploadStarted($event)"
                                (onUploadError)="uploadError($event)"
                                (onUploaded)="uploaded($event)"
                            >
                            </dx-file-uploader>
                        </div>
                    </dxi-item>
                </dxi-item>
            </dx-form>
        </div>
    </div>

    <div class="row" style="min-height: 300px">
        <div class="col-sm-9" style="padding-right: 0px">
            <div class="m-2">
                <dx-data-grid
                    #linesGrid
                    keyExpr="id"
                    class="lines-grid"
                    [dataSource]="invoiceLines"
                    height="600"
                    [columnAutoWidth]="false"
                    (onToolbarPreparing)="onToolbarPreparing($event)"
                    (onRowPrepared)="rowPrepare($event)"
                    (onExporting)="onExporting($event)"
                    [sorting]="'none'"
                    [showBorders]="true"
                >
                    <dxi-column dataField="lineNumber" [visible]="true" width="70" [sortIndex]="0" [sortOrder]="'asc'"></dxi-column>
                    <dxi-column dataField="orderLineDetail.orderLine?.order?.invoiceNumber" caption="SO #" width="65" cellTemplate="soTemplate"></dxi-column>
                    <dxi-column dataField="partNumber" caption="Part #" width="200" cellTemplate="linkTemplate"></dxi-column>
                    <dxi-column dataField="description" width="200"></dxi-column>
                    <dxi-column dataField="quantity" caption="Qty" width="65"></dxi-column>
                    <dxi-column dataField="price" caption="Price" width="120" alignment="right" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
                    <dxi-column
                        dataField="lineTotal"
                        caption="Total"
                        width="130"
                        alignment="right"
                        [format]="{ type: 'currency', precision: 2 }"
                        [allowEditing]="false"
                    ></dxi-column>
                    <dxi-column dataField="isTaxable" caption="Taxable" width="80"></dxi-column>
                    <dxi-column dataField="lineTax" caption="Tax" width="100" alignment="right" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
                    <dxi-column dataField="orderLineDetail.vIN" caption="VIN #" width="165" [allowEditing]="false"></dxi-column>
                    <dxi-column dataField="orderLineDetailId" width="65"></dxi-column>
                    <dxi-column width="100"></dxi-column>

                    <div *dxTemplate="let cell of 'soTemplate'">
                        <a [routerLink]="[]" (click)="openSalesOrder(cell.data.orderLineDetail?.orderLine?.orderId)">{{
                            cell.data.orderLineDetail?.orderLine?.order?.invoiceNumber
                        }}</a>
                    </div>

                    <div *dxTemplate="let cell of 'linkTemplate'">
                        <div
                            class="parent-part-number"
                            *ngIf="
                                cell.data?.orderLineDetail?.orderLine?.partId &&
                                !cell.data?.orderLineDetail?.orderLine?.parentLineId &&
                                !cell.data?.orderLineDetail?.orderLine?.isReplacement
                            "
                        >
                            {{ cell.text }}
                        </div>
                        <div class="replacement-part-number" *ngIf="cell.data?.orderLineDetail?.orderLine?.isReplacement">{{ cell.text }}</div>
                        <div
                            class="misc-part-number"
                            *ngIf="cell.data?.paymentLineTypeId !== 7 && !cell.data?.orderLineDetail?.orderLine?.partId && !cell.data?.orderLineDetail?.orderLine?.isReplacement"
                        >
                            {{ cell.text }}
                        </div>
                        <div class="option-part-number" *ngIf="cell.data?.orderLineDetail?.orderLine?.parentLineId">{{ cell.text }}</div>
                        <div class="fee-part-number" *ngIf="cell.data?.paymentLineTypeId === 7">{{ cell.text }}</div>
                    </div>

                    <div *dxTemplate="let data of 'toolbarButtons'">
                        <button
                            class="btn btn-sm btn-success me-2"
                            (click)="updateLinePrice()"
                            [disabled]="!canUpdatePricing || linesGrid.instance.getSelectedRowsData().length !== 1 || hasChanges()"
                            [hidden]="invoice.paid || showAsDialog"
                        >
                            Update Pricing
                        </button>
                        <button class="btn btn-sm btn-success ms-2 me-2" (click)="addFeeLine()" [disabled]="hasChanges()" [hidden]="invoice.paid || showAsDialog">
                            Add Invoice Fee
                        </button>
                        <button
                            class="btn btn-sm btn-danger me-2"
                            (click)="removeLine()"
                            [disabled]="linesGrid.instance.getSelectedRowsData().length !== 1 || hasChanges()"
                            [hidden]="invoice.paid || showAsDialog"
                        >
                            Remove Line
                        </button>

                        <button
                            class="btn btn-sm btn-danger me-2"
                            (click)="addInvoiceLine()"
                            [disabled]="hasChanges()"
                            [hidden]="showAsDialog || !canAddDetails || isInvoiceCredit"
                        >
                            Add Invoice Line from Build Detail
                        </button>

                        <button
                            class="btn btn-sm btn-danger"
                            (click)="creditLines()"
                            [disabled]="hasChanges() || linesGrid.instance.getSelectedRowsData().length === 0"
                            [hidden]="showAsDialog || !isInvoiceCredit"
                        >
                            Create Credit for Selected Lines
                        </button>
                    </div>
                    <div *dxTemplate="let data of 'toolbarText'"></div>

                    <dxo-export [enabled]="true"></dxo-export>
                    <dxo-selection mode="multiple"></dxo-selection>
                    <dxo-summary>
                        <dxi-total-item column="lineTotal" summaryType="sum" displayFormat="{0}" [valueFormat]="{ type: 'currency', precision: 2 }"> </dxi-total-item>
                    </dxo-summary>
                    <dxo-state-storing [enabled]="true" [storageKey]="'invoice-detail-grid'"></dxo-state-storing>
                </dx-data-grid>
            </div>
        </div>
        <div class="col-sm-3">
            <div class="d-flex">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Type/Method</th>
                            <th>Amount</th>
                            <th>QuickBooksId</th>
                        </tr>
                    </thead>
                    <tbody *ngIf="paymentLines && paymentLines.length > 0">
                        <tr class="table-secondary">
                            <td colspan="7"><strong>Payments</strong></td>
                        </tr>
                        <tr *ngFor="let c of paymentLines" (dblclick)="openPayment(c)">
                            <td class="payment-font">{{ c.payment.paymentDate | date: 'shortDate' }}</td>
                            <td class="payment-font">{{ c.payment.paymentMethod?.name }}{{ c.payment.paymentMethod?.name == 'Check' ? ' - ' + c.payment.referenceNumber : '' }}</td>
                            <td class="payment-font">{{ c.amount + c.creditAmount | currency }}</td>
                            <td class="payment-font">{{ c.payment.quickBooksId }}</td>

                            <td></td>
                            <td *ngIf="!c.payment?.quickBooksRefId && !showAsDialog" class="icon-collapse-horizontal">
                                <i class="fa fa-external-link" (click)="openPayment(c)"></i>
                            </td>
                            <td *ngIf="!c.payment?.quickBooksRefId && !showAsDialog" class="icon-collapse-horizontal"><i class="fa fa-pencil" (click)="openPayment(c)"></i></td>
                        </tr>
                    </tbody>
                    <tbody *ngIf="invoiceCredits && invoiceCredits.length > 0">
                        <tr class="table-secondary">
                            <td colspan="7"><strong>Credits</strong></td>
                        </tr>
                        <tr *ngFor="let credit of invoiceCredits" (dblclick)="openOrderDialog(credit.creditOrderId)">
                            <td class="payment-font">{{ credit.created | date: 'shortDate' }}</td>
                            <td class="payment-font">Credit{{ credit.paymentCreditType?.name ? ' - ' + credit.paymentCreditType.name : '' }}</td>
                            <td class="payment-font">{{ credit.creditAmount | currency }}</td>
                            <td class="payment-font">{{ credit.quickBooksId }}</td>

                            <td></td>
                            <td *ngIf="credit.creditOrderId && !showAsDialog" class="icon-collapse-horizontal">
                                <i class="fa fa-external-link" (click)="openOrderDialog(credit.creditOrderId)"></i>
                            </td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <div class="card">
        <div class="card-body">
            <dx-form #totalsForm [formData]="invoice" [colCount]="4" [readOnly]="readOnly">
                <dxi-item itemType="group">
                    <dxi-item [label]="{ text: 'Notes' }">
                        <div *dxTemplate>
                            <dx-text-area [(value)]="invoice.notes" [height]="200"></dx-text-area>
                        </div>
                    </dxi-item>
                </dxi-item>
                <dxi-item itemType="group" caption="Notes List" *ngIf="notesList">
                    @for (note of notesList; track note) {
                        <span>{{ note.created | date: 'MM/dd/yyyy hh:mm:ss aa' }} by {{ note.createdBy }}: {{ note.notes }} </span><br />
                    }
                </dxi-item>
                <dxi-item itemType="group" caption="Invoice QuickBooks" [colSpan]="1" [disabled]="true">
                    <dxi-item dataField="readyToExport" [editorOptions]="{ displayFormat: 'shortDateShortTime', readOnly: true }"></dxi-item>
                    <dxi-item dataField="quickBooksId" [editorOptions]="{ readOnly: true }"></dxi-item>
                    <dxi-item dataField="quickBooksLastExport" [editorOptions]="{ displayFormat: 'shortDateShortTime', readOnly: true }"></dxi-item>
                </dxi-item>

                <dxi-item itemType="group" caption="Payment Info" [colSpan]="1">
                    <dxi-item
                        dataField="paymentsTotal"
                        [label]="{ text: 'Payments' }"
                        editorType="dxNumberBox"
                        [editorOptions]="{ format: '$#,##0.00##', readOnly: true }"
                    ></dxi-item>
                    <dxi-item
                        dataField="invoiceBalance"
                        [label]="{ text: 'Balance' }"
                        editorType="dxNumberBox"
                        [editorOptions]="{ format: '$#,##0.00##', readOnly: true }"
                    ></dxi-item>
                    <dxi-item
                        *ngIf="invoice.paidByNorthpoint"
                        dataField="northPointPaymentAmount"
                        [label]="{ text: 'Northpoint Fee' }"
                        editorType="dxNumberBox"
                        [editorOptions]="{ format: '$#,##0.00##', readOnly: true }"
                    ></dxi-item>
                    <dxi-item dataField="paid" [editorOptions]="{ displayFormat: 'shortDateShortTime', readOnly: true }"></dxi-item>
                </dxi-item>
            </dx-form>
        </div>
    </div>
</div>
<div *ngIf="showAsDialog" class="modal-footer">
    <button class="btn btn-success" (click)="close()">Close</button>
</div>
